var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var cookies = document.cookie.split(";").reduce(function (ac, e) {
    var _a;
    var _b = e.trim().split("="), cookieName = _b[0], cookieValue = _b[1];
    return __assign(__assign({}, ac), (_a = {}, _a[cookieName] = decodeURIComponent(cookieValue), _a));
}, {});
export var getCookieCustomerNumber = function () {
    return decodeURIComponent(cookies["reece-account-number"]);
};
export var hasActiveMaxUserSession = function () {
    return !!cookies["reece-account-number"] && !!cookies["reece-user-profile"];
};
export var getCookiePunchoutSessionEpochStart = function () {
    var punchoutStart = parseInt(cookies["cart-punchout-session-epoch-start"]);
    return isNaN(punchoutStart) ? undefined : punchoutStart;
};
